"use client";

import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

import Button from "@/components/Button";

import styles from "./BlockTextImage.module.scss";
import classNames from "classnames";

interface Props {
  title: string;
  text: string;
  href?: string;
  hrefLabel?: string;
  image?: string;
  image_mobile?: string;
  invertPosition?: boolean;
}

export default function BlockTextImage(props: Props) {
  const { text, title, href, hrefLabel, image, invertPosition, image_mobile } =
    props;
  const [selectedImage, setSelectedImage] = useState(image);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setSelectedImage(image_mobile);
    } else {
      setSelectedImage(image);
    }
  }, [image, image_mobile]);

  const router = useRouter();
  return (
    <div
      className={classNames({
        [styles.BlockTextImage]: true,
        [styles.inverted]: invertPosition,
      })}
    >
      <div className={styles.BlockTextImage__content}>
        <h1>{title}</h1>
        {/* <hr className={styles.BlockTextImage__separator} /> */}
        <p>{text}</p>

        {href && (
          <Button
            onClick={() => {
              router.push(href);
            }}
            title={hrefLabel ? hrefLabel : "Saiba mais"}
            style={{
              marginTop: "1.5rem",
            }}
          />
        )}
      </div>

      <div
        className={styles.BlockTextImage__image}
        style={{
          backgroundImage: `url(${selectedImage})`,
        }}
      />
    </div>
  );
}
